// material
import { Stack, Typography, Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function Utility() {
  return (
    <>
      <Stack direction="row" sx={{ borderBottom: "1px solid #ffffff80" }}>
        <Box
          sx={{
            borderRight: "1px solid #ffffff80",
            width: "60%",
            fontFamily: "Helvetica",
            textAlign: "start",
            color: "#fff",
            pl: "20px",
            fontSize: { md: "140px", lg: "170px", xl: "200px" },
          }}
        >
          UTILITY
        </Box>
        <Box sx={{ width: "40%" }}></Box>
      </Stack>
      <Stack
        sx={{
          borderBottom: "1px solid #ffffff80",
          fontFamily: "Helvetica",
          textAlign: "start",
          color: "#fff",
          p: "40px",
          fontSize: { md: "30px", lg: "40px", xl: "50px" },
        }}
      >
        IRL EVENTS. EXCLUSIVE CONTENT. LIMITED EDITION DROPS. SPECIAL EDITION
        MERCH. COLLABORATIONS. LIKE-MINDED PEOPLE. GIGS. DISCOUNTS. ART. MUSIC.
        PLACES. EXPERIENCES. MEMORIES. SUPPORT. ALLOWLIST. KNOWLEDGE. ALPHA.
      </Stack>
    </>
  );
}
